define([
    'edge/platform/widgets/carousel/directives/GwCarousel',
    'edge/platform/widgets/carousel/ui-bootstrap-carousel/ui-bootstrap-carousel',

    // datetimepicker library tries to require() for angular inside (a bug)
    // it cases errors in case Webpack doesn't parse this file
    //'imports?require=>function(arg){return window[arg];}!datetimepicker'
], (carousel)=> {
    return angular.module('edge.platform.widgets.carousel', [
        'ui.bootstrap.carousel'
    ])
        .directive('gwCarousel', carousel);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/carousel/module.js